import React from 'react';
import T from 'prop-types';
import { isEmpty } from 'lodash-es';

import { AppItem, AppPlaceholder, AppItemMobile, AppPlaceholderMobile } from './AppsListItem';

const placeholder = [1, 2, 3, 4, 5];

export const AppsList = ({ apps, customTexts, onAppRemove, onPlaceholderClick }) => {
  return (
    <div className="report-analysis-applications-container">
      <div className="report-analysis-applications">
        {apps.map((app) => (
          <AppItem key={app.ref_no} app={app} onAppRemove={onAppRemove} />
        ))}
        {placeholder.slice(apps.length).map((item, i) => (
          <AppPlaceholder
            key={item}
            itemNumber={item}
            isActiveItem={i === 0}
            customTexts={customTexts}
            onPlaceholderClick={onPlaceholderClick}
          />
        ))}
      </div>
    </div>
  );
};

AppsList.propTypes = {
  apps: T.array,
  customTexts: T.object,
  onAppRemove: T.func,
  onPlaceholderClick: T.func,
};

// Mobile
export const AppsListMobile = ({
  apps,
  onAppRemove,
  onPlaceholderClick,
  placeholderSelected,
  preSelectedApp,
}) => {
  const appsLength = apps.length;
  const hasPreSelectedApp = !isEmpty(preSelectedApp);

  const showPulseAnimation =
    (appsLength === 0 && placeholderSelected !== 0) ||
    (hasPreSelectedApp && !placeholderSelected && appsLength === 1);

  const showSelected =
    (!hasPreSelectedApp && placeholderSelected === appsLength) ||
    (hasPreSelectedApp && placeholderSelected === appsLength && appsLength !== 1) ||
    (hasPreSelectedApp && placeholderSelected && appsLength === 1);

  return (
    <div className="app-selection-apps-list">
      {apps.map((app) => (
        <AppItemMobile key={app.ref_no} app={app} onAppRemove={onAppRemove} />
      ))}
      {placeholder.slice(apps.length).map((item, i) => (
        <AppPlaceholderMobile
          key={item}
          onPlaceholderClick={() => onPlaceholderClick(apps.length + i)}
          showPulseAnimation={i === 0 && Boolean(showPulseAnimation)}
          showSelected={i === 0 && Boolean(showSelected)}
        />
      ))}
    </div>
  );
};

AppsListMobile.propTypes = {
  apps: T.array,
  onAppRemove: T.func,
  onPlaceholderClick: T.func,
  placeholderSelected: T.number,
  preSelectedApp: T.array,
};
